'use strict';

var htmlTemplate = require('./htmlTemplate');

function createRoutes(_ref) {
    var path = _ref.path,
        htmlOptions = _ref.htmlOptions,
        _ref$amp = _ref.amp,
        amp = _ref$amp === undefined ? false : _ref$amp;

    var routes = [];

    function htmlHandler(request, reply) {
        reply(htmlTemplate(htmlOptions));
    }

    function ampHandler(request, reply) {
        reply(htmlTemplate(Object.assign({}, htmlOptions, { amp: true })));
    }

    if (path === '/') {
        routes.push({
            method: 'GET',
            path: path,
            handler: htmlHandler
        });
    } else {
        routes.push({
            method: 'GET',
            path: path + '/',
            handler: htmlHandler
        });
        // Sans-trailing-slash redirects to trailing slash
        routes.push({
            method: 'GET',
            path: path,
            handler: function handler(request, reply) {
                reply.redirect(path + '/');
            }
        });
    }

    if (amp) {
        routes.push({
            method: 'GET',
            path: path + '/amp/',
            handler: ampHandler
        });
    }

    return routes;
}

module.exports = createRoutes;


//////////////////
// WEBPACK FOOTER
// ./~/lokum/lib/createRoutesForHTML.js
// module id = 348
// module chunks = 0